module.exports = __webpack_public_path__ + "static/media/RetailerBanner.b5ad6040.webp";